// Enum for lot detail state avec labels multilingues
export const U3142LotStateEnum = [
  {
    value: "validate",
    label: {
      fr: "Validé",
      en: "Validated",
    },
  },
  {
    value: "notValidate",
    label: {
      fr: "Non Validé",
      en: "Not Validated",
    },
  },
];
